/** Shared tokens for every layer above the page; callsites name a size, never pick pixels. */

export const OVERLAY_SCRIM = "bg-black/40"

/** Not the `border` token: that is shadcn's slate, lighter than every panel edge in the app. */
export const OVERLAY_BORDER = "border-palette-jungleGreen200"

/** Not `90vh`: vh is scaled by `--app-zoom`, so use the corrected `--app-vh` (see index.css). */
export const OVERLAY_MAX_H = "max-h-[calc(var(--app-vh)-4rem)]"

export const PANEL_WIDTH = {
  default: "w-[460px]",
  wide: "w-[720px]",
} as const

const REGION_X = "px-6"

/** `pr-12` reserves the corner the close button sits in. */
export const OVERLAY_HEADER = `flex-shrink-0 border-b ${OVERLAY_BORDER} ${REGION_X} py-4 pr-12`

/** The only region that scrolls; `min-h-0` lets it shrink so title and buttons stay put. */
export const OVERLAY_BODY = `min-h-0 flex-1 space-y-5 overflow-y-auto ${REGION_X} py-5`

/** `flex-col-reverse` below `sm` keeps the primary action nearest the thumb. */
export const OVERLAY_FOOTER = `flex flex-shrink-0 flex-col-reverse gap-2 border-t ${OVERLAY_BORDER} ${REGION_X} py-4 sm:flex-row sm:justify-end`
